import {BranchesStates} from '../../States';

const INITIAL_STATE = localStorage.getItem('branches')
    ? JSON.parse(localStorage.getItem('branches'))
    : '';

export const BranchesReducer = (
    state = {branches: {...INITIAL_STATE}},
    action,
) => {
    const {type, payload} = action;

    switch (type) {
    case BranchesStates.SUCCESS:
        return {branches: {...payload}, reducer_status: BranchesStates.SUCCESS};

    case BranchesStates.FAILED:
        return {branches: {...payload}, reducer_status: BranchesStates.FAILED};

    case BranchesStates.RESET:
        return {branches: {...INITIAL_STATE}};

    default:
        return state;
    }
};
